import axios from 'axios'
import { StorageFactory } from './storageFactory'

export const localStore = StorageFactory(() => localStorage)

export const HTTP_WITHOUT_HEADER = () => {
  let origin = window.location.origin
  // let origin = 'https://new.pragyasystems.com'
  // let origin = 'http://localhost:8080/'

  let env = localStore.getItem('pragya_environment')
  if (env) {
    if (env === 'prod') {
      origin = 'https://www.pragyasystems.com'
    } else if (env === 'client') {
      origin = 'https://client.pragyasystems.com'
    } else if (env === 'new') {
      origin = 'https://new.pragyasystems.com'
    }
  }

  return axios.create({
    baseURL: origin + '/'
  })
}

export const HTTP = (token) => {
  let origin = window.location.origin

  let env = localStore.getItem('pragya_environment')
  if (env) {
    if (env === 'prod') {
      origin = 'https://www.pragyasystems.com'
    } else if (env === 'client') {
      origin = 'https://client.pragyasystems.com'
    } else if (env === 'new') {
      origin = 'https://new.pragyasystems.com'
    }
  }

  if (token !== undefined) {
    return axios.create({
      baseURL: origin + '/',
      headers: {
        Authorization: 'Bearer ' + token
      }
    })
  } else if (localStore.getItem('token')) {
    return axios.create({
      baseURL: origin + '/',
      headers: {
        Authorization: 'Bearer ' + localStore.getItem('token')
      }
    })
  } else {
    window.location.href = (window.location.host.indexOf('nunav') !== -1 || window.location.host.indexOf('competencyedu') !== -1) ? '/landing/views/nunav-landing.html' : '/landing/views/login.html'
  }
}

export const HTTP_FIREBASE_SHORTLINK = () => {
  return axios.create({
    baseURL: 'https://firebasedynamiclinks.googleapis.com/',
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export const sortObjects = (objects, key, reverse = false) => {
  /*
  Sorts a list of objects based on the value of their key property
   */
  let sortedKeys = Object.keys(objects).sort((a, b) => {
    if (reverse) return objects[b][key] - objects[a][key]
    return objects[a][key] - objects[b][key]
  })

  return sortedKeys.map((k) => {
    return objects[k]
  })
}



// WEBPACK FOOTER //
// ./widgetSrc/utils.js